<ng-container *ngIf="facialRecognitionButtonType == 1">
  <div class="facial-recognition-upload-photo-button rounded border cursor-pointer" (click)="takePhoto.emit()">
    <span class="d-lg-flex d-none flex-column align-items-center justify-content-center h-100">
      <span class="material-symbols-outlined mb-1"> camera_video </span>
      <label>{{ 'facial.recognition.button.use.webcam' | translate }}</label>
    </span>
    <span class="d-lg-none d-flex flex-column align-items-center justify-content-center h-100">
      <span class="icon material-icons mb-1">add_a_photo</span>
      <label>{{ 'facial.recognition.button.take.photo' | translate }}</label>
    </span>
  </div>
</ng-container>
<ng-container *ngIf="facialRecognitionButtonType == 2">
  <input type="file" id="uploadedImageInput" class="cursor-pointer" accept="image/*" (change)="changeImageFile($event)" hidden />
  <button *ngIf="smallUploadButton" class="btn btn-outline-info rounded facial-recognition-upload-photo-button-small p-0">
    <label for="uploadedImageInput" class="uploaded-image-input w-100 d-flex align-items-center justify-content-center m-0">
      <span class="icon material-icons me-2">backup</span>
      <span class="font-size-14 fw-bold mt-1">{{ 'facial.recognition.button.upload.photo' | translate }}</span>
    </label>
  </button>
  <label
    *ngIf="!smallUploadButton"
    for="uploadedImageInput"
    class="d-flex flex-column align-items-center justify-content-center facial-recognition-upload-photo-button rounded border cursor-pointer"
  >
    <span class="icon material-icons mb-1">backup</span>
    <span>{{ 'facial.recognition.button.upload.photo' | translate }}</span>
  </label>
</ng-container>
<ng-container *ngIf="facialRecognitionButtonType == 3">
  <button
    class="btn btn-success rounded text-white d-flex align-items-center justify-content-center mx-auto"
    (click)="capturePhoto.emit()"
  >
    <span class="font-size-14 fw-bold mt-1">{{ 'facial.recognition.button.capture.photo' | translate }}</span>
  </button>
</ng-container>
<ng-container *ngIf="facialRecognitionButtonType == 4">
  <button
    (click)="retakePhoto.emit()"
    class="btn rounded text-white facial-recognition-retake-photo-button d-flex align-items-center justify-content-center"
  >
    <span class="font-size-14 fw-bold mt-1">{{ 'facial.recognition.button.retake.photo' | translate }}</span>
  </button>
</ng-container>
<ng-container *ngIf="facialRecognitionButtonType == 5">
  <button
    (click)="submitphoto.emit()"
    class="btn btn-success rounded text-white d-flex align-items-center justify-content-center"
  >
    <span class="font-size-14 fw-bold mt-1">{{ 'facial.recognition.button.submit.photo' | translate }}</span>
  </button>
</ng-container>
<ng-container *ngIf="facialRecognitionButtonType == 6">
  <button
    (click)="closeModal()"
    [routerLink]="['/account']"
    class="btn btn-danger rounded text-white d-flex align-items-center justify-content-center mx-auto"
  >
    <span class="font-size-14 fw-bold mt-1">{{ 'facial.recognition.button.ok' | translate }}</span>
  </button>
</ng-container>
